<div class="counter">
  <div *ngIf="controls" class="pause" (click)="pause()" inlineSVG="sot/sot-icon.svg#sot-pause"
    [setSVGAttributes]="{class: 'icon-counter'}"></div>

  <div class="countdown" [ngClass]="statusClass">
    <div class="number">{{count}}</div>
    <svg>
      <circle [style.animation-duration]="circle_animation_duration" [style.animation-play-state]="statusClass" r="18.5"
        cx="20" cy="20"></circle>
    </svg>
  </div>

  <div *ngIf="controls" class="play" (click)="play()" inlineSVG="sot/sot-icon.svg#sot-play"
    [setSVGAttributes]="{class: 'icon-counter'}"></div>
</div>